import { render, staticRenderFns } from "./RuleTemplateDetail.vue?vue&type=template&id=61fd075e&"
import script from "./RuleTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./RuleTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports